import * as React from 'react';

import EpisodeEntry from '@/components/pages/podcast/components/PodcastPage/EpisodeEntry';
import { Container } from '@/components/pages/podcast/layout/Container';
import PodcastLayout from '@/components/pages/podcast/layout/PodcastLayout';
import Podcast from '@/types/pages/api/podcasts/Podcast';
import { useState } from 'react';
import type Episode from '@/types/pages/api/podcasts/Episode';

type PodcastPageProps = {
    podcast: Podcast;
    episodes: Episode[];
};

const PodcastPage = (props: PodcastPageProps) => {
    const { podcast, episodes } = props;
    const [episodesToShow, setEpisodesToShow] = useState<Episode[]>(episodes.slice(0, 12));

    return (
        <main className="border-gray-200 relative w-full">
            <PodcastLayout podcast={podcast}>
                <div>
                    <Container className="flex flex-col border-b lg:border-0 pt-8 pb-9">
                        <h1 className="text-2xl font-bold leading-7 text-slate-900 p-0 m-0">Episodes</h1>
                    </Container>
                    <div className="divide-y divide-slate-100 sm:pt-4 lg:pt-5 lg:border-t">
                        {episodesToShow.map(episode => (
                            <EpisodeEntry key={episode.id} episode={episode} />
                        ))}
                        {episodesToShow.length < episodes.length ? (
                            <Container className="py-12 px-2 xl:px-0">
                                <button
                                    onClick={() => setEpisodesToShow(episodes)}
                                    className="relative flex justify-center items-center hover:text-white gap-2 px-5 py-4 text-primary hover:bg-primary hover:border-primary border bg-white"
                                >
                                    <p className="text-sm text-center uppercase">load more</p>
                                </button>
                            </Container>
                        ) : null}
                    </div>
                </div>
            </PodcastLayout>
        </main>
    );
};

export default PodcastPage;
